module.exports = "/_next/static/images/Backup-d9184d644467a55af13789f23440898c.png";